import html2canvas from "html2canvas";

export type ExportFormat = "png" | "jpeg" | "svg";

export const exportChart = async (
  element: HTMLElement,
  fileName: string = "ai_generated_chart",
  format: ExportFormat = "jpeg"
) => {
  if (format === "svg") {
    const svg = element.querySelector("svg");
    if (!svg) return;

    const serializer = new XMLSerializer();
    const source = serializer.serializeToString(svg);

    const blob = new Blob([source], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${fileName}.svg`;
    link.click();

    URL.revokeObjectURL(url);
  } else {
    const canvas = await html2canvas(element, {
      ignoreElements: (el) => el.hasAttribute("data-no-export"),
    });
    const dataURL = canvas.toDataURL(`image/${format}`);

    const link = document.createElement("a");
    link.href = dataURL;
    link.download = `${fileName}.${format}`;
    link.click();
  }
};
